import { CALL_API } from "admin/middlewares/api";

export const GET_IM_TOKEN_REQUEST = "GET_IM_TOKEN_REQUEST";
export const GET_IM_TOKEN_SUCCESS = "GET_IM_TOKEN_SUCCESS";
export const GET_IM_TOKEN_ERROR = "GET_IM_TOKEN_ERROR";

export function get_token(userId, savelend) {
  const endpoint = savelend
    ? "/savelend/init-impersonation"
    : "/loanstep/init-impersonation";
  return {
    [CALL_API]: {
      endpoint: "/api/admin" + endpoint,
      authenticatedRequest: true,
      method: "POST",
      data: { Id: userId },
      types: [GET_IM_TOKEN_REQUEST, GET_IM_TOKEN_SUCCESS, GET_IM_TOKEN_ERROR],
    },
  };
}
